import { DeleteOutlined, EditOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Flex, Modal, Spin, Tooltip, Typography } from "antd";
import { useState } from "react";
import { PageHeader } from "../../../components/page-header";
import { EntPopulationFilter } from "../../../models/filters/populationFilter";
import { EntPopulation } from "../../../models/population";
import {
  useLazyGetPopulationListAllQuery
} from "../../../redux/api/population/populationApi";
import { AddPopulationModal } from "./AddPopulationModal";
import { usePopulation } from "./usePopulation";
import { ContentPartFilter } from "../../../components/content-part/ContentPartFilter";
import { FilterPopulations } from "./FilterPopulations";
import { useForm } from "antd/es/form/Form";
import _ from "lodash";
import { EmptyData } from "../../../components/empty/emptyData";
import { useTranslation } from "react-i18next";
import { useGetDataOnScroll } from "../../../components/getDataOnScrollProps/useGetDataOnScrollProps";
enum FormField {
  animalTypeIds,
  districtId,
  areaId,
  countFrom,
  countTo,
  page,
  size,
  deleted
}
export const Population = () => {
  const [modal, contextHolder] = Modal.useModal();
  const [form] = useForm();
  const {t} = useTranslation()
  const [selectedPopulation, setSelectedPopulation] = useState<EntPopulation>(new EntPopulation());
  const [showModal, setShowModal] = useState<boolean>(false);
  const { onAddPopulation, onEditPopulation, onDeletePopulation } = usePopulation(modal, () => { searchHandleClick()})
  const [height, setHeight] = useState<number>(0);

  const [getArchiveFolders] = useLazyGetPopulationListAllQuery();
  const {
    filter,
    fetching,
    data,
    totalItems,
    setData,
    setFetching,
    setFilter,
    scrollHandler,
    setCurrentPage
  } = useGetDataOnScroll<EntPopulation, EntPopulationFilter>({
    initialFilter: new EntPopulationFilter(),
    query: getArchiveFolders
  });
  const openAddModal = (role: EntPopulation) => {
    setSelectedPopulation(role);
    setShowModal(true);
  }
  const setEntityFromFields = (): EntPopulationFilter => {
    let filt: EntPopulationFilter = _.clone(filter);
    filt.animalTypeIds = form.getFieldValue(FormField.animalTypeIds) ?? null;
    filt.districtId = form.getFieldValue(FormField.districtId) ?? null;
    filt.areaId = form.getFieldValue(FormField.areaId) ?? null;
    filt.countFrom = form.getFieldValue(FormField.countFrom) ?? null;
    filt.countTo = form.getFieldValue(FormField.countTo) ?? null;
    filt.deleted = form.getFieldValue(FormField.deleted) ?? false;

    return filt;
  }
  const clearFields = () => {
    form.setFields([
      { name: FormField.animalTypeIds, value: null },
      { name: FormField.districtId, value: null },
      { name: FormField.areaId, value: null },
      { name: FormField.countFrom, value: null },
      { name: FormField.countTo, value: null },
      { name: FormField.deleted, value: false },
    ]);
  }
  const searchHandleClick = () => {
    setFilter(setEntityFromFields());
    setData([]);
    setCurrentPage(0);
    setFetching(true);
  }
  const table = (
    <div style={{ maxHeight: `${height}px`, overflow: 'auto' }} onScroll={scrollHandler}>
      <table>
        <thead>
          <tr>
            <th style={{ width: "40px" }}>#</th>
            <th>{ t('population.animal_type_population') }</th>
            <th>{ t('breeding_farms.quantity') }</th>
            <th>{ t('handbooks.regions.district') }</th>
            <th style={{ width: "120px" }}></th>
          </tr>
        </thead>
        <tbody>
          {fetching ?
            <tr>
              <th colSpan={5}>
                <Spin spinning={fetching} style={{
                  width: '100%',
                  height: '180px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }} />
              </th>
            </tr>
            : <></>}
          {data.length !== 0 ? data.map((item, index) => (
            <tr key={item.id}>
              <td>{++index}</td>
              <td>

                {item?.animalTypes !== undefined && item?.animalTypes !== null ? 
                  item.animalTypes.map((animalType, index) => (
                    <span key={index}>
                      {animalType.nameRu}
                    </span>
                  )) : <></>
                }
              </td>
              <td>{item?.count}</td>
              <td>{item?.area?.nameRu}</td>
              <td>
                <Flex gap="small">
                  <Tooltip title={ t('general.edit') }>
                    <Button className='btn_edit' onClick={() => { openAddModal(item) }} type="primary" shape="circle" icon={<EditOutlined />} />
                  </Tooltip>
                  <Tooltip title={ t('general.delete') }>
                    <Button className='btn_edit' danger onClick={() => { onDeletePopulation(item) }} type="primary" shape="circle" icon={<DeleteOutlined />} />
                  </Tooltip>
                </Flex>
              </td>
            </tr>
          )) : <tr>
          <td colSpan={5}>
            <EmptyData />
          </td>

        </tr>}
        </tbody>
      </table>
    </div>
  );
  return (
    <>
      <PageHeader
        title={ t('titles.register_of_population') }
        additionalInfo={
          <Typography.Text style={{ marginBottom: '0.5em', display: 'block' }} type="secondary">{t('population.population_desc')} {t('general.records_found')} {totalItems} </Typography.Text>
        } />
      <Button type="primary" icon={<PlusOutlined />} onClick={() => { openAddModal(new EntPopulation) }}>
        {t('population.add_population')}
      </Button>
      <ContentPartFilter
        filter={<FilterPopulations    onSearch={searchHandleClick}
        onReset={() => { clearFields(); searchHandleClick() }} formField={FormField} form={form} />}
        setHeight={setHeight}
        table={table}
      />
      <AddPopulationModal
        population={selectedPopulation}
        show={showModal}
        onHide={() => {
          setShowModal(false)
        }}
        onSubmit={selectedPopulation.id !== 0 ? onEditPopulation : onAddPopulation}
      />
      {contextHolder}
    </>
  )
}
